<template>
  <th v-if="isHeader">
    <!-- Table Header actions -->
    Actions
  </th>
  <td v-else>
    <!-- Table Body - Row actions -->
    <div>
      <dropdown v-if="$route.meta.isAdmin">
        <dropdown-action icon="edit" @click="onClickEdit">Edit {{ singular }}</dropdown-action>
        <dropdown-action icon="delete" @click="onClickDelete" v-if="canDelete">Delete {{ singular }}</dropdown-action>
        <slot name='extra'></slot>
      </dropdown>
    </div>
  </td>
</template>

<script>
import Dropdown from './Dropdown';
import DropdownAction from './DropdownAction';

import VuetableFieldMixin from 'vuetable-2/src/components/VuetableFieldMixin';

export default {
  name: 'category-actions',
  props: {
    routePath: {
      type: String,
      default: 'CategoryEdit',
    },
    id: [Number, String],
    deleteAction: {
      type: String,
      default: 'categories/delete',
    },
    singular: {
      type: String,
      default: 'category'
    },
    canDelete: {
      type: Boolean,
      default: true
    }
  },

  methods: {
    onClickEdit() {
      this.$router.push({
        name: this.routePath,
        params: { id: this.id || this.rowData.id },
      });
    },

    onClickDelete() {
      this.$store.dispatch('createDialog', {
        confirm: () => {
          this.$store
            .dispatch(
              this.deleteAction,
              this.id || this.rowData.id,
            )
            .then((response) => {});
        },
      });
    },
  },

  components: {
    Dropdown,
    DropdownAction,
  },

  mixins: [VuetableFieldMixin],
};
</script>
